/* eslint-disable react/no-danger */
/* eslint-disable arrow-body-style */
import React from 'react'
import styles from './twoColumnVideo.module.scss'
import VideoPlayer from './VideoPlayer'

const TwoColumnVideoLayout = data => {
  return data?.twoColumnvideoData?.twoColumnVideoLayoutType === 'Video in 1st column, Content in 2nd column' ? (
    <div className={styles.twoColumnVideoContainer}>
      <div className={styles.videoPlayerStyles}>
        <VideoPlayer
          isMobile={data?.isMobileDevice}
          videoContentFull={data?.twoColumnvideoData}
        />
      </div>
      <div className={styles.twoColumnVideoContent}>
        <span dangerouslySetInnerHTML={{ __html: data?.twoColumnvideoData?.twoColumnVideoSectionContent }} />
      </div>
    </div>
  ) : (
    <div className={styles.twoColumnVideoContainer}>
      <div className={styles.twoColumnVideoContent}>
        <span dangerouslySetInnerHTML={{ __html: data?.twoColumnvideoData?.twoColumnVideoSectionContent }} />
      </div>
      <div className={styles.videoPlayerStyles}>
        <VideoPlayer
          isMobile={data?.isMobileDevice}
          videoContentFull={data?.twoColumnvideoData}
        />
      </div>
    </div>
  )
}

export default TwoColumnVideoLayout
